module.exports = __webpack_public_path__ + "img/59.fa75dbf4.jpg";